// 初始化数据
const modal = {
  areaList: [], // 行政区域
  areaAllList: [], // 行政区域扁平化数据
  searchResult: [], // 列表数据
  tableLoading: false, // 列表loading
  deleteLoading: false, // 删除按钮loading
  submitLoading: false, // 新增/编辑提交按钮 loading
  modalData: {
    type: 1, // 1 - 新建, 2 - 编辑
    data: {},
    visible: false,
  },
};
export default modal;
